<template>
   <el-tabs type="border-card">
        <el-tab-pane label="新增文章">
            <div style="margin-top:16px;" >
                <el-form ref="form" :model="form" label-width="120px">
                    <el-form-item label="文章标题">
                        <el-input v-model.trim="form.title" placeholder="文章标题"></el-input>
                    </el-form-item>
                    <el-form-item label="文章简介">
                        <el-input v-model.trim="form.introduction" placeholder="文章简介"></el-input>
                    </el-form-item>
                    <el-form-item label="缩略图">
                      <el-upload
                        :action="serverUrl"
                        list-type="picture-card"
                        :accept="'image/*'"
                        :on-preview="handlePictureCardPreview"
                        :on-success="uploadSuccMethod"
                        :on-error="uploadFail"
                        :on-remove="handleRemove">
                        <i class="el-icon-plus"></i>
                      </el-upload>
                      <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="form.pictureUrl" alt="">
                      </el-dialog>
                    </el-form-item>
                    <el-form-item label="文章关键字">
                        <el-input v-model.trim="form.keywords" placeholder="文章关键字"></el-input>
                    </el-form-item>
                    <el-form-item label="文章类型">
                        <el-select v-model="form.tagId" placeholder="请选择">
                          <el-option
                            v-for="item in tagData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                          </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="文章标签">
                      <el-select v-model="form.typeId" placeholder="请选择">
                        <el-option
                          v-for="item in typeData"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item label="文章内容" style="height:500px">
                      <el-upload
                        class="avatar-uploader"
                        :action="serverUrl"
                        name="file"
                        multiple
                        :show-file-list="false"
                        :on-success="uploadSuccess"
                        :on-error="uploadError"
                        :before-upload="beforeUpload"></el-upload>
                      <quill-editor
                       v-loading="quillUpdateImg"
                       style="height:360px;width:795px;"
                       class="editor"
                       v-model="form.content"
                       ref="myQuillEditor"
                       :options="editorOption"
                       @blur="onEditorBlur($event)"
                       @focus="onEditorFocus($event)"
                       @change="onEditorChange($event)"></quill-editor>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="onSubmit">立即创建</el-button>
                        <el-button size="mini">取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-tab-pane>
    </el-tabs>
</template>
<script>
  import {quillEditor } from 'vue-quill-editor'
  export default {
    props: {
      /*编辑器的内容*/
      value: '',
      /*图片大小*/
      maxSize: {
        default: 4000 //kb
      }
    },
    data() {
      return {
        form: {
          title: '',
          keywords: '',
          introduction: '',
          pictureUrl: '',
          typeId: '',
          tagId: '',
          content:  this.value,
          token: this.user.getToken()
        },
        dialogVisible: false,
        tagData: [],
        typeData: [],
        quillUpdateImg: false,
        serverUrl: "https://admin.ruidan.com/api/upload/load", // 这里写你要上传的图片服务器地址
        // serverUrl: "http://127.0.0.1:7006/upload/load",
        pagination: {
          pageSize: 10,
          pageNum: 1,
          pageTotal: 0
        },
        editorOption: {
          theme: "snow", // or 'bubble'
          placeholder: "请填写文章内容...",
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                image: function(value) {
                  if (value) {
                    // 触发input框选择图片文件
                    document.querySelector(".avatar-uploader input").click();
                  } else {
                    this.quill.format("image", false);
                  }
                },
              }
            }
          }
        } 
      }
    },
    components: {
      quillEditor
    },
    watch: {
      value(val) {
        this.form.content = this.value
      }
    },
    methods: {
      onSubmit() {
        // 初始化默认加载菜单
        this.form.token = this.user.getToken()
        this.http.post(
          '/article/add', 
          this.form, res => {
            if (res.success) {
              // 返回正确的处理
              this.$router.push("/article/list")
            } else {
              // 返回错误的处理
              this.$message.error(res.message)
            }
        });
      },
      onEditorBlur() {
       //失去焦点事件
      },
      onEditorFocus() {
        //获得焦点事件
      },
      onEditorChange({ editor, html, text }) {
        this.form.content = html;
        console.log(html)
        //内容改变事件
        this.$emit("textareaData", this.form.content);
      },
      // 富文本图片上传前
      beforeUpload() {
        // 显示loading动画
        this.quillUpdateImg = true;
      },
      uploadSuccess(res, file) {
        // res为图片服务器返回的数据
        // 获取富文本组件实例
        let quill = this.$refs.myQuillEditor.quill;
        // 如果上传成功
        if (res.code == 200) {
          // 获取光标所在位置
          let length = quill.getSelection().index;
          // 插入图片  res.url为服务器返回的图片地址
          quill.insertEmbed(length, "image", res.data);
          // 调整光标到最后
          quill.setSelection(length + 1);
        } else {
          this.$message.error("图片插入失败");
        }
        // loading动画消失
        this.quillUpdateImg = false;
      },
      // 富文本图片上传失败
      uploadError() {
        // loading动画消失
        this.quillUpdateImg = false;
        this.$message.error("图片插入失败");
      },
      getTag() {
        this.optionItem = this.common.extend({token: this.user.getToken()}, this.pagination);
        // 初始化默认加载菜单
        this.http.post(
          '/articleTag/list',
          this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.tagData = res.datas.data
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
      },
      getType() {
         this.optionItem = this.common.extend({token: this.user.getToken()}, this.pagination);
        // 初始化默认加载菜单
        this.http.post(
          '/articleType/list',
          this.optionItem, res => {
          if (res.success) {
            // 返回正确的处理
            this.typeData = res.datas.data
          } else {
            // 返回错误的处理
            this.$message.error(res.message)
          }
        });
      },
      handleRemove(file, fileList) {
        this.form.pictureUrl = ''
      },
      handlePictureCardPreview(res) {
        this.dialogVisible = true;
      },
      uploadSuccMethod(res) {
        console.log("返回图片地址："+res.data)
        this.form.pictureUrl = res.data;
      },
      uploadFail() {
        // loading动画消失
        this.$message.error("图片插入失败");
      }
    },
    mounted() {
      this.getTag()
      this.getType()
    }
  }
  // 工具栏配置
  const toolbarOptions = [
    ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
    ["blockquote", "code-block"], // 引用  代码块
    // [{ header: 1 }, { header: 2 }], // 1、2 级标题
    [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
    [{ script: "sub" }, { script: "super" }], // 上标/下标
    [{ indent: "-1" }, { indent: "+1" }], // 缩进  2
    [{ color: [
      '#ffffff', '#ffd7d5', '#ffdaa9', '#fffed5', '#d4fa00', '#73fcd6', '#a5c8ff', '#ffacd5', '#ff7faa',
      '#d6d6d6', '#ffacaa', '#ffb995', '#fffb00', '#73fa79', '#00fcff', '#78acfe', '#d84fa9', '#ff4f79',
      '#b2b2b2', '#d7aba9', '#ff6827', '#ffda51', '#00d100', '#00d5ff', '#0080ff', '#ac39ff', '#ff2941',
      '#888888', '#7a4442', '#ff4c00', '#ffa900', '#3da742', '#3daad6', '#0052ff', '#7a4fd6', '#d92142',  
      '#000000', '#7b0c00', '#ff0000', '#d6a841', '#407600', '#007aaa', '#021eaa', '#797baa', '#ab1942'
    ] }, { background: [
      '#ffffff', '#ffd7d5', '#ffdaa9', '#fffed5', '#d4fa00', '#73fcd6', '#a5c8ff', '#ffacd5', '#ff7faa',
      '#d6d6d6', '#ffacaa', '#ffb995', '#fffb00', '#73fa79', '#00fcff', '#78acfe', '#d84fa9', '#ff4f79',
      '#b2b2b2', '#d7aba9', '#ff6827', '#ffda51', '#00d100', '#00d5ff', '#0080ff', '#ac39ff', '#ff2941',
      '#888888', '#7a4442', '#ff4c00', '#ffa900', '#3da742', '#3daad6', '#0052ff', '#7a4fd6', '#d92142',  
      '#000000', '#7b0c00', '#ff0000', '#d6a841', '#407600', '#007aaa', '#021eaa', '#797baa', '#ab1942'
    ] }], // 字体颜色、字体背景颜色
    [{ size: ["small", false, "large", "huge"] }], // 字体大小 2
    [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
    [{ font: [] }], // 字体种类 2
    [{'direction': 'rtl'}],               // 文本方向  2
    [{ align: [] }], // 对齐方式 2
    ["clean"], // 清除文本格式
    ["link", "image", "video"] // 链接、图片、视频
  ];
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/views/aritcle/aritcleAdd.vue